<template>
  <div id="app">
    <div id="nav">
      <router-link to="/">NFT Creator</router-link> |
      <router-link to="/about">NFTtoZFT</router-link>
    </div>
    <router-view/>
    <Footer></Footer>
  </div>
</template>
<script>
import Footer from './components/Footer'
export default {
  name: "App",
  components:{
    Footer
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}

#nav {
  padding: 30px;
}

#nav a {
  padding: 10px;
  font-weight: bold;
  color: #2c3e50;
  border-radius: 5px;
}

a.disabled {
  pointer-events: none;
  cursor: default;
}

#nav a.router-link-exact-active {
  background-color: #42b983;
  color: white;
}
</style>
